import React, { useContext } from "react";
import SelectionItem from "../SelectionItem";
import Type1 from "./images/1.png";
import Type2 from "./images/2.png";
import Type3 from "./images/3.png"; // import Type4 from "./images/4.png";

import Type5 from "./images/5.png"; // import Type6 from "./images/6.png";

import "./index.scss";
import { StepContext } from "../StepContext";
import { useTranslation } from "../../i18n";

const PageSelectProblem = ({
  selectStep
}) => {
  const {
    _t
  } = useTranslation();
  const {
    isPatient
  } = useContext(StepContext);
  const types = [{
    key: "ET",
    img: Type1,
    name: isPatient ? _t("Отсутствуют зубы") : _t("Протезирование")
  }, {
    key: "EM",
    img: Type2,
    name: isPatient ? _t("Некрасивая форма зубов") : _t("Эстетические реставрации")
  }, // { key: "problem3", img: Type3, name: "Боль в зубах, кариес, пульпит" },
  // Воспаленные десна
  // { key: "problem4", img: Type4, name: "Зубы слишком темные" },
  {
    key: "OM",
    img: Type5,
    name: isPatient ? _t("Не ровные зубы") : _t("Ортодонтический модуль")
  }, {
    key: "TM",
    img: Type3,
    name: isPatient ? _t("Боль в зубах, кариес, пульпит") : _t("Терапевтический модуль") // comingSoon: _t("Ожидается..."),

  }];

  function setStep(key) {
    selectStep(key);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "pageSelectProblem"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pageSelectProblem-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    innerTitle: el.name,
    disabled: el.comingSoon,
    selectText: el.comingSoon
  }))));
};

export default PageSelectProblem;